import { patternFormatter } from 'react-number-format';

import { COUNTRY_CODE_PREFIX, PHONE_VIEW_FORMAT } from '../../../constants/phoneFormat';

/**
 * form value "+11231231231" -> "+1 (123) 123 1231"
 * value without 10 digit national number is returned as is (patternFormatter shifts digits)
 */
export const getPhoneView = (phone?: string | null): string => {
  const value = phone ?? '';
  const digits = value.replace(/\D/g, '');
  const hasCountryCode =
    value.startsWith(COUNTRY_CODE_PREFIX) ||
    (digits.length === 11 && digits.startsWith('1'));
  const nationalNumber = hasCountryCode ? digits.slice(1) : digits;

  return nationalNumber.length === 10
    ? patternFormatter(nationalNumber, { format: PHONE_VIEW_FORMAT })
    : value;
};
